'use client'
import { AFFILIATE_CLICKED_REFS_KEY } from '@/config/global-config'
import { updateAffiliateClick } from '@/features/ref/services'
import { getReferralDataForAuth } from '@/features/save-log'
import { useAccountStore } from '@/store'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

/**
 * Component để track và update affiliate click từ URL ref parameter
 * - Chỉ call API 1 lần cho mỗi mã ref khác nhau
 * - Lưu danh sách các mã đã click vào localStorage
 * - Không call API nếu mã ref trùng với increment_id của user hiện tại
 */
export const UpdateAffiliateClick = () => {
  const searchParams = useSearchParams()
  const { data: userData } = useAccountStore()

  useEffect(() => {
    // Lấy mã ref từ URL search params
    const refCode = searchParams.get('ref')

    // Không làm gì nếu không có mã ref
    if (!refCode) return

    // Nếu user đã login và mã ref trùng với increment_id của user, không call API
    if (userData?.increment_id && refCode === userData.increment_id) {
      console.log('Mã ref trùng với mã của bản thân, không track')
      return
    }

    // Kiểm tra localStorage xem mã này đã được track chưa
    const clickedRefsString = localStorage.getItem(AFFILIATE_CLICKED_REFS_KEY)
    const clickedRefs: string[] = clickedRefsString ? JSON.parse(clickedRefsString) : []

    // Nếu mã đã được track rồi, không call API nữa
    if (clickedRefs.includes(refCode)) {
      console.log(`Mã ref ${refCode} đã được track trước đó`)
      return
    }

    // Lấy referral tracking data từ localStorage (nếu có)
    const referralData = getReferralDataForAuth()
    const camp = referralData?.camp || ''
    const additionalData = referralData ? JSON.stringify(referralData) : ''

    // Call API để update affiliate click với referral data
    updateAffiliateClick(refCode, camp, additionalData)
      .then((result) => {
        if (result !== undefined) {
          // Lưu mã ref vào danh sách đã click
          const updatedRefs = [...clickedRefs, refCode]
          localStorage.setItem(AFFILIATE_CLICKED_REFS_KEY, JSON.stringify(updatedRefs))
          console.log(`Đã track affiliate click cho mã: ${refCode}`)
        }
      })
      .catch((error) => {
        // Silent fail - đã được handle trong service
        console.error('Failed to track affiliate click:', error)
      })
  }, [searchParams, userData?.increment_id])

  // Component không render gì cả
  return null
}
